import './textarea.scss';
import React, { ChangeEvent, TextareaHTMLAttributes } from 'react';
import classNames from 'classnames';
import TextareaAutosize from 'react-textarea-autosize';
import { Size } from '../../../shared/types/size';

export interface ZenInputTextareaProps extends Omit<TextareaHTMLAttributes<HTMLTextAreaElement>, 'size' | 'prefix'> {
    size?: Size;
    className?: string;
    rounded?: 'square' | 'circle' | 'round' | Size;
    disabled?: boolean;
    value?: string | ReadonlyArray<string> | number | undefined;
    name?: string;
    onChange?: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
    onBlur?: (e: ChangeEvent) => void;
    minRows?: number;
    maxRows?: number;
    autoGrow?: boolean;
    placeholder?: string;
}

const ZenInputTextarea = React.forwardRef<HTMLTextAreaElement, ZenInputTextareaProps>(
    (
        // eslint-disable-next-line
        { minRows, maxRows, className, size, rounded = 'sm', value, onChange, onBlur, autoGrow = false, name, disabled, placeholder },
        ref,
    ) => {
        const classList = () => {
            return classNames([
                {
                    [`zen-textarea-${size}`]: size,
                    [`rounded-4`]: rounded === 'sm',
                    [`rounded-10`]: rounded === 'md',
                    [`rounded-15`]: rounded === 'lg',
                },
                `zen-textarea border overflow-hidden`,
                className,
            ]);
        };
        if (!autoGrow) {
            maxRows = minRows;
        }
        return (
            <div className={classList()}>
                <TextareaAutosize
                    ref={ref}
                    name={name}
                    className={`p-14`}
                    minRows={minRows}
                    maxRows={maxRows}
                    value={value || ''}
                    onChange={onChange}
                    onBlur={onBlur}
                    disabled={disabled}
                    placeholder={placeholder}
                />
            </div>
        );
    },
);
ZenInputTextarea.displayName = 'ZenInputTextarea';

export default ZenInputTextarea;
